export const STAMPS_SCAN_STATUS = {
  IN_PROGRESS: 'inprogress',
  COMPLETED: 'completed',
  ERROR: 'error',
};

export const MODULE_NAME = 'arcade-page-wrapper';
